import API from "../../service/api"

class User extends API{
    async group_list(){
        return await this.sendget(`group/user/group_list/`)
        //return await this.sendget(`account/user/notification_unread_count/`)
    }
  async group_join_list(){
      return await this.sendget("group/user/group_join_list/")
  }
  async member_apply(groupinfoID){
    return await this.sendget(`group/user/member_apply/?groupinfoID=${groupinfoID}`)
  }
  async group_claim(groupinfoID){
        return await this.sendget(`group/user/group_claim/?groupinfoID=${groupinfoID}`)
    }
  async group_update(params){
    return await this.sendpost(`group/user/group_update/`,params)
  }
  async group_remove(groupinfoID){
     return await this.sendpost(`group/passport/group_remove/?groupinfoID=${groupinfoID}`)
   }
  async member_remove(params){
    return await this.sendget(`group/user/member_remove/?groupinfoID=${params.groupinfoID}&userID=${params.userID}`)
  }
  async member_invite(params){
   return await this.sendget(`group/user/member_invite/?groupinfoID=${params.groupinfoID}&userID=${params.userID}`)
  }
  async topic_add(params){
    return await this.sendget(`group/user/topic_add/?groupinfoID=${params.groupinfoID}&name=${params.name}`)
  }
  async topic_remove(params){
    return await this.sendget(`group/user/topic_remove/?groupinfoID=${params.groupinfoID}&id=${params.id}`)
  }
  async group_other_list(){
        return await this.sendget("group/page/group_list/")
   }
  async group_join_article_list(lastID){
    return await this.sendget("group/user/group_join_article_list/?lastID="+lastID)
  }


  async sendget(url){
    try{
        let rs = await this.get(url);
        return rs;
    }
    catch(e){
        console.log(e)
        return false;
    }
  }

  async sendpost(url,data){
      try{
          let rs = await this.post(url,data);
          return rs;
      }
      catch(e){
          console.log(e)
          return false;
      }
  }
}
export default new User();